import { Eye, TrendingUp, Users, DollarSign } from 'lucide-react';
import KPICard from './KPICard';
import type { KPICardData } from '../../types/analytics.types';

export type { KPICardData };

const ICON_MAP: Record<string, React.ElementType> = {
  Eye,
  TrendingUp,
  Users,
  DollarSign,
};

export interface KPICardsGridProps {
  cards: KPICardData[];
}

export const KPICardsGrid: React.FC<KPICardsGridProps> = ({ cards }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-1">
        <span className="text-sm" style={{ color: '#464554B2' }}>
          ☆
        </span>
        <span
          className="text-sm font-bold tracking-widest uppercase"
          style={{ color: '#464554B2' }}
        >
          Primary Metrics
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((kpi, index) => {
          const ResolvedIcon =
            typeof kpi.icon === 'string'
              ? ICON_MAP[kpi.icon] || Eye
              : kpi.icon || Eye;

          return (
            <KPICard
              key={index}
              title={kpi.title}
              value={kpi.value}
              icon={ResolvedIcon}
              iconBg={kpi.iconBg}
              iconColor={kpi.iconColor}
              badge={kpi.badge || kpi.subtitle}
              badgeColor={kpi.badgeColor === 'gray' ? 'gray' : 'green'}
              barGradient={kpi.barGradient}
              info={kpi.info}
            />
          );
        })}
      </div>
    </div>
  );
};

export default KPICardsGrid;
